import React from 'react';
import { STAT_NUMS } from '../data/constants';

const Stats = ({ t }) => (
  /* full-width bg */
  <div className="w-full bg-white border-b border-line">
    {/* max-width content */}
    <div className="max-w-[1440px] mx-auto px-[120px] h-[136px] box-border grid grid-cols-5">
      {t.stats.map((label, i) => (
        <div
          key={label}
          className={`flex flex-col items-center justify-center gap-2 ${i !== 0 ? 'border-l border-line' : ''}`}
        >
          <div className="font-heading font-medium text-[46px] leading-none text-navy">
            {STAT_NUMS[i]}
          </div>
          <div className="text-[12px] font-semibold tracking-widest uppercase text-muted text-center">
            {label}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default Stats;
